import { render, staticRenderFns } from "./ParcelTracking.vue?vue&type=template&id=6406e952&scoped=true&"
import script from "./ParcelTracking.vue?vue&type=script&lang=js&"
export * from "./ParcelTracking.vue?vue&type=script&lang=js&"
import style0 from "./ParcelTracking.vue?vue&type=style&index=0&id=6406e952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6406e952",
  null
  
)

export default component.exports